import CategoryService from '@/services/CategoryService';

const initialState = {
	categories: []
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setCategories(state, payload) {
			state.categories = payload;
		},
		reset(state) {
			Object.assign(state, initialState);
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getCategories({ commit }) {
			try {
				const res = await CategoryService.getAllCategoriesAsync();
				if (res.data.Code === 200) {
					commit('setCategories', res.data.Data);
				}
				return res.data;
			} catch (error) {
				console.log(error);
			}
		},

		resetState({ commit }) {
			commit('reset');
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
